var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as facilityActions from '../actions/facility';
var initialState = {
  communicationsEnabledChanging: false,
  textingEnabledChanging: false,
  audioCallingEnabledChanging: false,
  videoCallingEnabledChanging: false,
  musicEnabledChanging: false,
  referenceMaterialEnabledChanging: false
};
export default function (state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case facilityActions.COMMUNICATIONS_ENABLED_CHANGING:
      return __assign(__assign({}, state), {
        communicationsEnabledChanging: true
      });
    case facilityActions.COMMUNICATIONS_ENABLED_CHANGE_FAILED:
      return __assign(__assign({}, state), {
        communicationsEnabledChanging: false,
        communicationsEnabledChangeError: action.error
      });
    case facilityActions.COMMUNICATIONS_ENABLED_CHANGED:
      return __assign(__assign({}, state), {
        communicationsEnabledChanging: false,
        communicationsEnabledChangeError: null
      });
    case facilityActions.TEXTING_ENABLED_CHANGING:
      return __assign(__assign({}, state), {
        textingEnabledChanging: true
      });
    case facilityActions.TEXTING_ENABLED_CHANGE_FAILED:
      return __assign(__assign({}, state), {
        textingEnabledChanging: false,
        textingEnabledChangeError: action.error
      });
    case facilityActions.TEXTING_ENABLED_CHANGED:
      return __assign(__assign({}, state), {
        textingEnabledChanging: false,
        textingEnabledChangeError: null
      });
    case facilityActions.AUDIO_CALLING_ENABLED_CHANGING:
      return __assign(__assign({}, state), {
        audioCallingEnabledChanging: true
      });
    case facilityActions.AUDIO_CALLING_ENABLED_CHANGE_FAILED:
      return __assign(__assign({}, state), {
        audioCallingEnabledChanging: false,
        audioCallingEnabledChangeError: action.error
      });
    case facilityActions.AUDIO_CALLING_ENABLED_CHANGED:
      return __assign(__assign({}, state), {
        audioCallingEnabledChanging: false,
        audioCallingEnabledChangeError: null
      });
    case facilityActions.VIDEO_CALLING_ENABLED_CHANGING:
      return __assign(__assign({}, state), {
        videoCallingEnabledChanging: true
      });
    case facilityActions.VIDEO_CALLING_ENABLED_CHANGE_FAILED:
      return __assign(__assign({}, state), {
        videoCallingEnabledChanging: false,
        videoCallingEnabledChangeError: action.error
      });
    case facilityActions.VIDEO_CALLING_ENABLED_CHANGED:
      return __assign(__assign({}, state), {
        videoCallingEnabledChanging: false,
        videoCallingEnabledChangeError: null
      });
    case facilityActions.MUSIC_ENABLED_CHANGING:
      return __assign(__assign({}, state), {
        musicEnabledChanging: true
      });
    case facilityActions.MUSIC_ENABLED_CHANGE_FAILED:
      return __assign(__assign({}, state), {
        musicEnabledChanging: false,
        musicEnabledChangeError: action.error
      });
    case facilityActions.MUSIC_ENABLED_CHANGED:
      return __assign(__assign({}, state), {
        musicEnabledChanging: false,
        musicEnabledChangeError: null
      });
    case facilityActions.REFERENCE_MATERIAL_ENABLED_CHANGING:
      return __assign(__assign({}, state), {
        referenceMaterialEnabledChanging: true
      });
    case facilityActions.REFERENCE_MATERIAL_ENABLED_CHANGE_FAILED:
      return __assign(__assign({}, state), {
        referenceMaterialEnabledChanging: false,
        referenceMaterialEnabledChangeError: action.error
      });
    case facilityActions.REFERENCE_MATERIAL_ENABLED_CHANGED:
      return __assign(__assign({}, state), {
        referenceMaterialEnabledChanging: false,
        referenceMaterialEnabledChangeError: null
      });
  }
  return state;
}